export default "__VITE_ASSET__dG$rzDGj__"